<template>
  <component :is="tag" :class="$style.tag" @click="handleClick">
    <template v-if="type == 'image'">
      <img :class="$style.idea" :src="src" />
    </template>
    <slot />
  </component>
</template>

<script>
import VueTypes from 'vue-types'
import VisibleListener from '../../utils/visible.listener'
import request from '../../utils/request'

export default {
  name: 'ad-event',
  components: {
  },
  props: {
    // 组件的标签
    tag: VueTypes.string.def('div'),
    // 素材类型
    type: VueTypes.oneOf(['image', 'video', 'text', 'location']).def('image'),
    // 监听的事件
    trigger: VueTypes.array.def(['visible', 'click']),
    // 点击事件是否阻止冒泡
    stop: VueTypes.bool.def(true),
    // 曝光的高度判断
    scale: VueTypes.number.def(50),
    // 素材地址
    src: VueTypes.string,
    // 监听的事件地址
    idea: VueTypes.shape({
      route: String,
      visible: String,
      click: String
    }).loose
  },
  data () {
    return {
      reportImage: new Image()
    }
  },
  computed: {
    useVisible () {
      return this.trigger.indexOf('visible') >= 0
    },
    useClick () {
      return this.trigger.indexOf('click') >= 0
    }
  },
  created () {
  },
  mounted () {
    this.initVisible()
  },
  methods: {
    /**
     * 初始化曝光的方法
     */
    initVisible () {
      if (!this.useVisible) {
        return
      }

      this.io = new VisibleListener({scale: this.scale})

      this.io.add(this.$el, visible => {
        visible && this.handleVisible()
      })
    },
    /**
     * 执行已曝光的方法
     */
    handleVisible () {
      this.io.remove(this.$el)
      this.report('visible')
      this.$emit('visible')
    },
    /**
     * 执行已点击的方法
     */
    handleClick (event) {
      this.stop && event.stopPropagation()

      this.useClick && this.report('click')
      this.$emit('click')

      this.idea.route && window.open(this.idea.route)
    },
    report (type) {
      switch (type) {
        case 'visible':
          if (this.idea.visible) {
            this.fetch(this.idea.visible)
            // this.reportImage.src = this.idea.visible
          }
          break
        case 'click':
          if (this.idea.click) {
            this.fetch(this.idea.click)
            // this.reportImage.src = this.idea.click
          }
          break
        default:
          break
      }
    },
    fetch (url) {
      const opt = {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true,
        type: 'get',
        url
      }

      return request(opt)
      // fetch(url, {
      //   headers: {
      //     'content-type': 'application/json'
      //   },
      //   method: 'GET',
      //   credentials: 'include'
      // })
    }
  }
}
</script>

<style lang="scss" module>
.tag {
  cursor: pointer;
}
.idea {
  display: block;
  width: 100%;
}
</style>

